import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">Alvi Construction</h3>
            <p className="footer-description">
              Building excellence since 2005. Your trusted partner for all construction needs.
            </p>
            <div className="social-links">
              <a href="#" aria-label="Facebook">📘</a>
              <a href="#" aria-label="Twitter">🐦</a>
              <a href="#" aria-label="Instagram">📷</a>
              <a href="#" aria-label="LinkedIn">💼</a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('home')}>Home</button></li>
              <li><button onClick={() => scrollToSection('services')}>Services</button></li>
              <li><button onClick={() => scrollToSection('about')}>About Us</button></li>
              <li><button onClick={() => scrollToSection('projects')}>Projects</button></li>
              <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul className="footer-links">
              <li>Commercial Construction</li>
              <li>Residential Building</li>
              <li>Renovation & Remodeling</li>
              <li>Project Management</li>
              <li>Design & Planning</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
              <ul className="footer-contact">
              <li>📍 KB Aman Ali Road, Boromia Mosjid, Chawk Bazar, Chattagram</li>
              <li>📞 <a href="tel:+8801818456866" aria-label="Call 01818-456866">01818-456866</a>, <a href="tel:+8801618456866" aria-label="Call 01618-456866">01618-456866</a></li>
              <li>✉️ <a href="mailto:jaforjarif@gmail.com">jaforjarif@gmail.com</a></li>
              {/* <li>🕒 Mon-Fri: 8AM - 6PM</li> */}
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Alvi Construction. Developed and Maintained by <a href="https://nextgentechies.sbs/" className="footer-credit-link" target="_blank" rel="noopener noreferrer"><strong>SiJu Tech</strong></a>.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
